import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useDeleteProduct, useGetProducts } from "hooks/useProduct";
import ProductCellActions from "./ProductCellActions";
import ProductImagePlaceholder from "../../assets/images/placeholder/product.png";
import { RootState } from "slices";
import { useSelector } from "react-redux";

function Products() {
  document.title = "Papermap | Products";
  const selectedBranch = useSelector(
    (state: RootState) => state.branch?.currentBranch
  );
  const { mutate } = useDeleteProduct();
  const [resource, setResource] = useState<any>(null);

  const navigate = useNavigate();

  const { data, isLoading } = useGetProducts(selectedBranch?.id);

  // delete resource
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (resource.id) {
      mutate(resource.id);
      setDeleteModal(false);
    }
  };

  const handleEditClick = (productId: number) => {
    console.log(productId);
    navigate(`/edit-product/${productId}`);
  };

  const handleAddProductClick = () => {
    navigate("/new-product");
  };

  // const handleViewProduct = (productId: number) => {
  //   console.log(productId);
  //   navigate(`/view-product/${productId}`);
  // };

  const columns = useMemo(
    () => [
      {
        header: "Product ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Image",
        accessorKey: "images",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => (
          <div className="flex-shrink-0 me-3">
            <div className="avatar-sm bg-light rounded p-2">
              <img
                className="img-fluid rounded d-block"
                src={
                  cellProps.row.original.images[0]?.url
                    ? cellProps.row.original.images[0].url
                    : ProductImagePlaceholder
                }
                alt="alt"
                style={{ objectFit: "cover", width: "100%", height: "100%" }}
              />
            </div>
          </div>
        ),
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <div>
            {cellProps.row.original.description.length > 20
              ? `${cellProps.row.original.description.substring(0, 20)}...`
              : cellProps.row.original.description}
          </div>
        ),
      },
      {
        header: "Cost Price",
        accessorKey: "cost_price",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <p style={{ margin: "0", padding: "0" }}>
            {cellProps.row.original.cost_price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        ),
      },
      {
        header: "Selling Price",
        accessorKey: "selling_price",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <p style={{ margin: "0", padding: "0" }}>
            {cellProps.row.original.selling_price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        ),
      },
      {
        header: "Quantity",
        accessorKey: "quantity",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <ProductCellActions
            productData={cellProps.row.original}
            onView={() => {}}
            onEdit={() => {}}
            onDelete={(productData) => onClickDelete(productData)}
          />
        ),
      },
    ],
    [handleEditClick]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Products" breadcrumbItem="View Products" />
          {isLoading ? (
            <Spinners />
          ) : (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={handleAddProductClick}
                      isPagination={true}
                      SearchPlaceholder="Search products..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                      buttonName=" Add New Product"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
    </React.Fragment>
  );
}

export default Products;
